'use strict';

// Service for retrieving color references by job ID
var ColorReferenceService = /*@ngInject*/ function(
  $http,
  REST_URL
) {
  var _self = this;

  _self.getColorReferencesByJobId = function(jobId) {
    return $http.get(REST_URL.base + '/colorReference/job/' + jobId);
  };
};

module.exports = ColorReferenceService;
